// useMovieDetailAnalytics customHook

import { useEffect, useMemo } from "react";

import { MovieTabsOption } from "./MovieDetail.types";
import useAnalytics from "hooks/analytics/useAnalytics";

const useMovieDetailAnalytics = (props: UseMovieDetailAnalyticsProps) => {
  const { isSuccessFetchMovie, movieTitle, activeTab } = props;
  const analyticsHook = useAnalytics({
    isSnackWorkflow: false
  });
  const { logViewMovieDetails, canBeSendAnalytics } = analyticsHook;
  const { logSelectTrailer } = analyticsHook;

  useEffect(() => {
    if (!canBeSendAnalytics) return;
    if (!isSuccessFetchMovie) return;

    logViewMovieDetails({
      name: movieTitle,
      section: activeTab
    });
  }, [
    activeTab,
    canBeSendAnalytics,
    isSuccessFetchMovie,
    logViewMovieDetails,
    movieTitle
  ]);

  return useMemo(
    () => ({
      logSelectTrailer
    }),
    [logSelectTrailer]
  );
};

export default useMovieDetailAnalytics;

interface UseMovieDetailAnalyticsProps {
  isSuccessFetchMovie: boolean;
  movieTitle: string | undefined;
  activeTab: MovieTabsOption;
}
